<template>
  <div class="row">
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      :id="`modalSeparate_${group_prescription_medicine.prescription_medicine_time.id}`"
      title="SEPARAR"
    >
      <Separate
        v-on:success="paginate"
        v-on:checked="$emit('checked')"
        :resident_id="resident_id"
        :date="date"
        :group_prescription_medicine="group_prescription_medicine"
      />
    </b-modal>
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      :id="`modalNotSeparate_${group_prescription_medicine.prescription_medicine_time.id}`"
      title="NÃO SEPARAR"
    >
      <NotSeparate
        v-on:success="paginate"
        v-on:checked="$emit('checked')"
        :resident_id="resident_id"
        :medicine_check="group_prescription_medicine.medicine_check"
        :group_prescription_medicine="group_prescription_medicine"
      />
    </b-modal>
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      :id="`modalCheck_${group_prescription_medicine.prescription_medicine_time.id}`"
      title="CHECAR"
    >
      <Check
        v-on:success="paginate"
        v-on:checked="$emit('checked')"
        v-on:cancel="
          $bvModal.hide(
            `modalCheck_${group_prescription_medicine.prescription_medicine_time.id}`
          )
        "
        :resident_id="resident_id"
        :date="date"
        :group_prescription_medicine="group_prescription_medicine"
        :prescription_medicine_time="
          group_prescription_medicine.prescription_medicine_time
        "
        :medicine_check="group_prescription_medicine.medicine_check"
        :stock_id="group_prescription_medicine.medicine_check.separate_stock_id"
      />
    </b-modal>
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex check-justifique-right"
    >
      <div v-if="$store.state.online">
        <div
          v-if="
            group_prescription_medicine.prescription_medicine.frequency ==
            'EVENTUAL'
          "
        >
          <v-btn
            v-if="
              group_prescription_medicine.prescription_medicine.show_separate
            "
            class="btn-add m-1 check-block"
            @click="handleSeparate"
            ><i class="fas fa-pills mr-2 text-twenty"></i> SEPARAR</v-btn
          >
          <div
            v-for="(item, key) of group_prescription_medicine
              .prescription_medicine.quantity_of_times_checked"
            :key="key"
          >
            <v-btn
              v-if="item.status == 'SEPARADO'"
              class="btn-delete m-1"
              @click="handleNotSeparate"
              >NÃO SEPARAR</v-btn
            >
            <v-btn
              v-if="item.status == 'SEPARADO'"
              class="btn-save m-1"
              @click="handleCheck"
              >CHECAR</v-btn
            >
          </div>
        </div>
        <div
          v-if="
            group_prescription_medicine.prescription_medicine.frequency !=
            'EVENTUAL'
          "
        >
          <v-btn
            v-if="
              !group_prescription_medicine.medicine_check.id &&
              group_prescription_medicine.prescription_medicine.frequency !=
                'EVENTUAL'
            "
            class="btn-add m-1 check-block"
            @click="handleSeparate"
            ><i class="fas fa-pills mr-2 text-twenty"></i> SEPARAR</v-btn
          >
          <v-btn
            v-if="
              group_prescription_medicine.medicine_check.status == 'SEPARADO'
            "
            class="btn-delete m-1"
            @click="handleNotSeparate"
            >NÃO SEPARAR</v-btn
          >
          <v-btn
            v-if="
              group_prescription_medicine.medicine_check.status == 'SEPARADO'
            "
            class="btn-save m-1"
            @click="handleCheck"
            >CHECAR</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Separate from "./Action/Separate";
import NotSeparate from "./Action/NotSeparate";
import Check from "./Action/Check";

export default {
  name: "Action",
  components: { Separate, NotSeparate, Check },
  props: {
    resident_id: [String, Number],
    date: [String, Number],
    group_prescription_medicine: Object,
  },
  data() {
    return {
      accessed_offline: false,
    };
  },
  created() {
    this.accessed_offline = JSON.parse(
      sessionStorage.getItem("accessed_offline") || !this.$store.state.online
    );
  },
  methods: {
    handleSeparate() {
      let { group_prescription_medicine } = this;
      this.$bvModal.show(
        `modalSeparate_${group_prescription_medicine.prescription_medicine_time.id}`
      );
    },
    handleNotSeparate() {
      let { group_prescription_medicine } = this;
      this.$bvModal.show(
        `modalNotSeparate_${group_prescription_medicine.prescription_medicine_time.id}`
      );
    },
    handleCheck() {
      let { group_prescription_medicine } = this;
      this.$bvModal.show(
        `modalCheck_${group_prescription_medicine.prescription_medicine_time.id}`
      );
    },
    paginate() {
      let { group_prescription_medicine } = this;
      this.$bvModal.hide(
        `modalSeparate_${group_prescription_medicine.prescription_medicine_time.id}`
      );
      this.$bvModal.hide(
        `modalNotSeparate_${group_prescription_medicine.prescription_medicine_time.id}`
      );
      this.$bvModal.hide(
        `modalCheck_${group_prescription_medicine.prescription_medicine_time.id}`
      );
      this.$emit("success");
    },
  },
};
</script>
